import Vue from "vue";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import PortalVue from "portal-vue";
import VueAnalytics from "vue-analytics";

import "./plugins/bootstrap";
import "./plugins/icons";
import "./plugins/murmur";

import routes from "./router";
import guards from "./router/guards";
import messages from "./i18n";
import store from "./store";
import "./main.scss"; 

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(PortalVue);

const i18n = new VueI18n({ locale: "en", messages });
const mode = '';
const router = guards({ router: new VueRouter({ routes, mode }), i18n });
const render = (h) => h("div", { attrs: { id: "app" } }, [h("RouterView")]);

Vue.use(VueAnalytics, {
  id: 'UA-3383794-15',
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: '/investigations/cyprus-confidential/service-providers-cyprus-leak/#/' + route.path,
        title: "Cyprus Confidential firms - Cyprus Confidential",
        location: window.location.href
      };
    },
  },
});

new Vue({ router, render, i18n, store }).$mount("#app");
